import { cookieWithName } from "./cookieHandling";

export function appType(): AppType {
    const appTypeCookie = cookieWithName("appType")
    if (appTypeCookie === undefined) {
        return AppType.NO_APP;
    }
    const appType = appTypeCookie.split("=")[1]
    if (appType) {
        if (appType === 'ios') {
            return AppType.IOS
        } else if (appType === 'android') {
            return AppType.ANDROID
        }
    }
    return AppType.NO_APP;
}

function appVersion(): string | undefined {
    const appVersion = cookieWithName("appVersion")
    return appVersion?.split("=")[1]
}

export enum AppType {
    IOS = "ios",
    ANDROID = "android",
    NO_APP = "",
}

function isVersionGreaterEqual(v1: string, v2: string) {
    const v1Numbers = v1.split(".").map(Number);
    const v2Numbers = v2.split(".").map(Number);

    if (v1Numbers.some(isNaN) || v2Numbers.some(isNaN)) throw Error("Invalid input version!")

    const len = Math.max(v1Numbers.length, v2Numbers.length);

    for (let i = 0; i < len; i++) {
        const v1Num = v1Numbers[i] ?? 0;
        const v2Num = v2Numbers[i] ?? 0;
        if (v1Num !== v2Num) return v1Num > v2Num;
    }
    return true;
}

export function supportedAppVersion(minAppVersions:{
    android: string;
    ios: string;
}) {
    const version = appVersion();
    if (version  === undefined) {
        return false;
    }

    try {
        if (appType() === AppType.ANDROID && isVersionGreaterEqual(version, minAppVersions.android)) {
            return true
        } else if (appType() === AppType.IOS && isVersionGreaterEqual(version, minAppVersions.ios)) {
            return true 
        }
    } catch {
        return false;
    }
    return false
}
